import { injectable } from "inversify";
import { Result, ok, err } from "neverthrow";
import { IBusStopLite, BusStopLite } from "@/domain/entities/busStop";
import { ParseError } from "../../shared/errors/parseError";
import {
  HttpBusStopLite,
  IBusStopLiteParser,
} from "../lineInfoRepository.types";

@injectable()
export class BusStopLiteParser implements IBusStopLiteParser {
  toDomain(data: HttpBusStopLite): Result<IBusStopLite, ParseError> {
    try {
      const busStopLite = new BusStopLite({
        id: data.uid,
        busStopName: data.name,
        gateNoList: data.gateNoList,
      });

      return ok(busStopLite);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
